/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// TODO fix and remove eslint disables
import { analytics, auth } from '../Firebase';
import { setUserId } from 'firebase/analytics';
import { authState } from 'rxfire/auth';
import { doc } from 'firebase/firestore';
import { db } from '../Firebase';
import { decodable } from '../rxjs/Decode';
import { map, filter, switchMap, shareReplay, combineLatest, Observable, BehaviorSubject, timer, race, merge, startWith, debounceTime, } from 'rxjs';
import { UserClaimsT } from '../shared/codecs/UserClaims';
import { decodeWith } from '../shared/firebase/decodeHelper';
import { combineUserClaimsAndOrg } from './utilities';
import { OrganizationT } from '../shared/codecs/Organization';
import { docData } from 'rxfire/firestore';
import { AuthTimeout } from '../utilities/Constants';
export const firebase_user = authState(auth).pipe(filter((u) => u !== null), shareReplay(1));
export const refresh_claims_token = new BehaviorSubject(true);
export const user_token = combineLatest([firebase_user, refresh_claims_token]).pipe(
// TODO
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
switchMap(([user]) => user.getIdToken()), shareReplay(1));
const custom_claims = combineLatest([firebase_user, refresh_claims_token]).pipe(switchMap(async ([user]) => {
    const tokenResult = await (user === null || user === void 0 ? void 0 : user.getIdTokenResult(true));
    const decodedUserClaims = decodeWith(UserClaimsT, tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.claims);
    return decodedUserClaims;
}), filter((claims) => !!claims), shareReplay(1));
export const organization = custom_claims.pipe(switchMap(({ organization }) => {
    return docData(doc(db, 'organizations', organization)).pipe(decodable(OrganizationT), shareReplay(1));
}), shareReplay(1));
const user_with_auth_state = combineLatest([firebase_user, custom_claims.pipe(startWith(undefined)), organization.pipe(startWith(undefined))]).pipe(map(([user, claims, org]) => combineUserClaimsAndOrg([user, claims, org])), shareReplay(1));
const auth_timeout = timer(AuthTimeout).pipe(map(() => ({ state: 'NoAccount' })));
const app_user_timeout = race(auth_timeout, user_with_auth_state).pipe(filter((app_user) => app_user.state === 'NoAccount'));
const app_user_with_timeout = merge(user_with_auth_state, app_user_timeout).pipe(debounceTime(350));
export const app_user = new BehaviorSubject({ state: 'Loading' });
export const signed_in_user = app_user.pipe(filter((u) => u.state === 'Authed' || u.state === 'NoSubscription'), shareReplay(1));
export const authed_user = app_user.pipe(filter((user) => user.state == 'Authed'), shareReplay(1));
app_user_with_timeout.subscribe(app_user);
firebase_user.subscribe(u => setUserId(analytics, u.uid));
firebase_user.subscribe(x => {
    console.log(`firebase_user`, x);
});
custom_claims.subscribe(x => {
    console.log(`claims`, x);
});
organization.subscribe(x => {
    console.log(`org`, x);
});
user_with_auth_state.subscribe(x => {
    console.log(`userauth`, x);
});
app_user_with_timeout.subscribe(x => {
    console.log(`usertimeout`, x);
});
app_user.subscribe(x => {
    console.log(`app_user`, x);
});
